import { z } from 'zod';

export const UsefulLifeDueSelectionItemSchema = z.object({
  identityKey: z.string().min(1),
  itemKind: z.enum(['PRODUCT', 'SERVICE']),
  displayName: z.string().min(1).max(300),
  catalogGenericProductId: z.uuid().nullable(),
  tenantProductId: z.uuid().nullable(),
  serviceCanonicalName: z.string().nullable(),
  serviceTypeCanonicalName: z.string().nullable(),
});

export type UsefulLifeDueSelectionItem = z.infer<typeof UsefulLifeDueSelectionItemSchema>;

export const ReplaceUsefulLifeDueSelectionBodySchema = z.object({
  items: z.array(UsefulLifeDueSelectionItemSchema),
});

export type ReplaceUsefulLifeDueSelectionBody = z.infer<
  typeof ReplaceUsefulLifeDueSelectionBodySchema
>;

export const UsefulLifeDueSelectionResponseSchema = z.object({
  items: z.array(UsefulLifeDueSelectionItemSchema),
  addedLineCount: z.number().int().nonnegative(),
});

export type UsefulLifeDueSelectionResponse = z.infer<typeof UsefulLifeDueSelectionResponseSchema>;
